import { Sbom } from '@kw/quokka-ui';

export default function SbomTab({ sbomData }: { sbomData?: any[] }) {
  return (
    <div>
      <Sbom data={sbomData} />
    </div>
  );
}
